import React from 'react';

const ProductsView = (props) => {
    return (
        <div>
            Products view
        </div>
    );
}

export default ProductsView;